/* eslint-disable react/jsx-no-target-blank */
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useUserStateProvider} from '../../../../../app/utils/contextProvider/UserStateProvider'
import {ENV_CLIENT} from '../../../../../app/modules/config'

const SidebarMenuRoleWise = () => {
  const {roleDetailMenus} = useUserStateProvider()
  const isAllowedDLR = ENV_CLIENT === 'ranksitt' || ENV_CLIENT === 'agni'

  const visibleMenus = roleDetailMenus.map((menu) => {
    if (!isAllowedDLR && menu.menu_name === 'Push Management' && menu.submenus?.length) {
      return {
        ...menu,
        submenus: menu.submenus.filter((submenu) => submenu.submenu_name !== 'DLR Push'),
      }
    }

    return menu
  })

  return (
    <>
      {/* Role wise menu */}
      {visibleMenus.map((menu) => {
        if (menu.submenus) {
          if (menu.view_level === 'Y') {
            return (
              <SidebarMenuItemWithSub to={menu.menu_link} title={menu.menu_name} icon={menu.icon}>
                {menu.submenus?.map((submenu) => {
                  if (submenu.view_level === 'Y') {
                    return (
                      <SidebarMenuItem
                        to={submenu.submenu_link}
                        title={submenu.submenu_name}
                        hasBullet={true}
                      />
                    )
                  }
                })}
              </SidebarMenuItemWithSub>
            )
          }
        }

        if (menu.view_level === 'Y') {
          return <SidebarMenuItem to={menu.menu_link} title={menu.menu_name} icon={menu.icon} />
        }
      })}
    </>
  )
}

export {SidebarMenuRoleWise}
